// This store holds all application specific configuration. The config file is loaded
// from a dedicated CloudFront route that reads it from an S3 bucket. For the specific
// configuration values, look in the CDK project.
import {
  isDevEnv,
  isTestEnv,
} from '@amzn/woot-services-vendor-portal-core/utils/environment'
import { createWithImmer } from '@amzn/woot-services-vendor-portal-core/utils/stores'

type ConfigStore = {
  applicationId: string | null
  identityPoolId: string | null
  nextPublicApiMocking: boolean
  hydrate: () => Promise<void>
  isLoading: boolean
  supergraphProxyUrl: string
  apiKeyFileLocation: string
}

// cache config file
let configFile: ConfigStore

const fetchConfig = async () => {
  if (!configFile) {
    const response = await fetch('/app-config')
    if (response.status === 200) {
      const result = (await response.json()) as ConfigStore
      configFile = result
    } else {
      console.error(
        'there was an error retrieving the application config',
        response.status,
      )
    }
  }

  return configFile
}

const loadDevConfig = () => {
  return {
    applicationId: 'application-id',
    identityPoolId: 'identity-pool-id',
    nextPublicApiMocking:
      process.env.NEXT_PUBLIC_API_MOCKING === 'false' ? false : true,
    supergraphProxyUrl: '/graphql',
    apiKeyFileLocation: process.env.API_KEY_FILE || '.api-key',
  } as ConfigStore
}

const loadTestConfig = () => {
  return {
    ...loadDevConfig(),
    supergraphProxyUrl: 'http://doesntmatter.example.com',
  }
}

export const useConfigStore = createWithImmer<ConfigStore>((set) => ({
  applicationId: null,
  identityPoolId: null,
  nextPublicApiMocking: false,
  isLoading: true,
  supergraphProxyUrl: '',
  localDomain: '',
  apiKeyFileLocation: '',
  hydrate: async () => {
    let config: ConfigStore

    if (isTestEnv()) {
      config = loadTestConfig()
    } else if (isDevEnv()) {
      config = loadDevConfig()
    } else {
      config = await fetchConfig()
    }

    set((state) => {
      state.applicationId = config.applicationId
      state.identityPoolId = config.identityPoolId
      state.nextPublicApiMocking = config.nextPublicApiMocking
      state.isLoading = false
      state.supergraphProxyUrl = config.supergraphProxyUrl
      state.apiKeyFileLocation = config.apiKeyFileLocation
    })
  },
}))
